import { Button, Icon } from '@material-ui/core';

const AddButton = ({
  label,
  onAddNewRecord,
  icon,
  customClassName = 'bg-green-400 text-white hover:bg-green-500',
  disabled
}) => {
  return (
    <Button
      type="button"
      variant="contained"
      className={customClassName}
      disabled={disabled}
      startIcon={icon && <Icon>{icon}</Icon>}
      onClick={onAddNewRecord}>
      {label}
    </Button>
  );
};

export default AddButton;
